import { createSlice } from "@reduxjs/toolkit";

export interface NavDetailState {
  nav: [] | null | any;
  currentAddress: [] | null | any;
  currentLocation: [] | null | any;
  addressData: [] | null | any;
  id: [] | null | any;
  data: [] | null | any;
  isLoggedIn: [] | null | any;
  PaymentDetail: {} | [] | null | any;
  fromLocation: {} | null | any;
  toLocation: {} | null | any;
  TypeName: null | any;
  tripDetails: null | any;
  bookingDetails: null | any;

}

const initialState = {
  nav: null,
  currentAddress: null,
  isError: false,
  isLoading: false,
  isSuccess: false,
  currentLocation: null,
  message: "",
  addressData: null,
  id: null,
  data: null,
  isLoggedIn: null,
  PaymentDetail: null,
  fromLocation: null,
  toLocation: null,
  TypeName: null,
  tripDetails: null,
  bookingDetails: null,
};

export const navSlice = createSlice({
  name: "nav",
  initialState,
  reducers: {
    setNavData: (state, action) => {
      state.nav = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },
    setFromLocation: (state, action) => {
      console.log(action, 'setFromLocation,action')
      state.fromLocation = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },
    setToLocation: (state, action) => {
      state.toLocation = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },

    setTypeName: (state, action) => {
      state.TypeName = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },
    setCurrentAddressData: (state, action) => {
      state.currentAddress = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },
    setCurrentLocationData: (state, action) => {
      state.currentLocation = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },
    setLocationData: (state, action) => {
      state.addressData = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },
    setSubCategory: (state, action) => {
      state.id = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },

    setTimeZone: (state, action) => {
      state.data = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },
    setIsLoggedInValue: (state, action) => {
      state.isLoggedIn = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },
    setPaymentDetail: (state, action) => {
      state.PaymentDetail = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },
    setTripDetails: (state, action) => {
      state.tripDetails = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },
    setBookingDetails: (state, action) => {
      state.bookingDetails = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = true;
      state.message = "Navigation Successful";
    },

    resetNav: (state) => {
      state = initialState;
    },
  },
});

export const { setNavData, setFromLocation, setToLocation, setCurrentAddressData, setCurrentLocationData, setLocationData, resetNav, setSubCategory, setTimeZone, setIsLoggedInValue, setPaymentDetail, setTypeName, setTripDetails, setBookingDetails } =
  navSlice.actions;
export const getAddress = (state: any) => state.nav.currentAddress;
export const getLocation = (state: any) => state.nav.currentLocation;
export const getFromLocation = (state: any) => state.nav.fromLocation;
export const getToLocation = (state: any) => state.nav.toLocation;
export const getAddressData = (state: any) => state.nav.addressData;
export const getSubCategoryData = (state: any) => state.nav.id;
export const getTimeZone = (state: any) => state.nav.data;
export const getIsLoggedInData = (state: any) => state.nav.isLoggedIn;
export const getPaymentDetail = (state: any) => state.nav.PaymentDetail;
export const getTypeName = (state: any) => state.nav.TypeName;
export const getTripDetails = (state: any) => state.nav.tripDetails;
export const getBookingDetails = (state: any) => state.nav.bookingDetails;

export default navSlice.reducer;
